import { useState } from "react";

const Toast = ({getMsg}:any) =>{
  const commMsg = getMsg();
  const [toastOption,setToastOption] = useState<any>({active:false});

  const win:any = window;

  win.alert = (msg:string,callback:Function) =>{

    let option = {...toastOption};

    option['active'] = true;
    option['msg'] = msg;
    option['type'] = 'alert';
    option['callBack'] = callback;
    
    setToastOption(option);
  }

  win.confirm = (msg:string,callback:Function) =>{
    let option = {...toastOption};

    option['active'] = true;
    option['msg'] = msg;
    option['type'] = 'confirm';
    option['callBack'] = callback;

    setToastOption(option);

  }

  const positiveClick = () =>{
    if(toastOption['callBack']){
      toastOption['callBack']();
    }
    setToastOption({active:false});
  }

  return (
    <>
      <div className={"toast toast-mobile fade " + (toastOption['active'] ? "show" : "hide")}>
          <div className="toast-header">
              <strong className="toast-tit mr-auto">{commMsg['notice']}</strong>
              <button type="button" className="btn btn-transparent close" onClick={()=>{setToastOption({...toastOption,active:false})}}></button>
          </div>
          <div className="toast-body">
              <p className="text-center">{toastOption['msg']}</p>
          </div>
          <div className="toast-foot btn-group">
              <button type="button" className="btn btn-popup positive" onClick={positiveClick}>{commMsg['confrimBtn']}</button>
              {toastOption['type'] === 'confirm' && <button type="button" className="btn btn-popup negative" onClick={()=>{setToastOption({...toastOption,active:false})}}>취소</button>}
          </div>
      </div>

      <div className={"toast-backdrop toast-backdrop-3 fade " + (toastOption['active'] ? "show" : "hide")}></div>
    </>
  );
}

export default Toast;